module.exports = __webpack_public_path__ + "static/media/no-image.8dc2c281.png";